module.exports = __webpack_public_path__ + "media/flags/bo-30e99b54.svg";